import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { ChallengeProvider } from './context/ChallengeContext';
import App from './App';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const basename = import.meta.env.MODE === 'production' ? '/' : '/';

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter basename={basename}>
      <AuthProvider>
        <ChallengeProvider>
          <App />
        </ChallengeProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);